import { ENV_STAGING } from '@mymahi/environment';

export const environment = {
    ...ENV_STAGING
};
